/**
 * 无顶栏/侧栏的独立页（对齐 EB layout/index.vue standalonePage）
 */
export const CRMEB_STANDALONE_ROUTE_NAMES = ['NotificDiyation'] as const;

export function isCrmebStandaloneRoute(routeName: string | symbol | null | undefined): boolean {
  if (routeName == null) return false;
  return (CRMEB_STANDALONE_ROUTE_NAMES as readonly string[]).includes(String(routeName));
}
